// src/components/map/ImportPanel.js
/* global XLSX */
import React, { useState, useEffect, useRef } from 'react';

export default function ImportPanel({ onImport, onCancel }) {
  const [text, setText] = useState('');
  const fileInputRef = useRef(null);

  // PROJ4-строка из вашего Python-скрипта
  const PROJ4_MGGT = [
    '+proj=tmerc',
    '+lat_0=55.66666666667',
    '+lon_0=37.5',
    '+k=1',
    '+x_0=16.098',
    '+y_0=14.512',
    '+ellps=bessel',
    '+towgs84=316.151,78.924,589.650,-1.57273,2.69209,2.34693,8.4507',
    '+units=m',
    '+no_defs'
  ].join(' ');

  useEffect(() => {
    if (!window.proj4) {
      console.error('proj4 не загружен!');
      return;
    }
    window.proj4.defs('MGGT', PROJ4_MGGT);
    window.proj4.defs('WGS84', window.proj4.WGS84);
  }, []);

  // Когда хотим конвертировать координаты и передать наверх
  const emitCoords = coords => {
    onImport(coords);
    onCancel();
  };

  // Парсим из текста
  const handleDraw = () => {
    const PAT = /X=\s*([-\d.]+)\s*Y=\s*([-\d.]+)/gi;
    const coords = [];
    let m;
    while ((m = PAT.exec(text)) !== null) {
      const x = parseFloat(m[1]);
      const y = parseFloat(m[2]);
      const [lon, lat] = window.proj4('MGGT', 'WGS84', [x, y]);
      coords.push([lat, lon]);
    }
    emitCoords(coords);
  };

  // Парсим из Excel (A → X, B → Y)
  const handleFileUpload = e => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = evt => {
      const data = new Uint8Array(evt.target.result);
      const wb = XLSX.read(data, { type: 'array' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const coords = rows
        .filter(r => r.length >= 2 && !isNaN(r[0]) && !isNaN(r[1]))
        .map(r => {
          const [lon, lat] = window.proj4(
            'MGGT', 'WGS84',
            [ parseFloat(r[0]), parseFloat(r[1]) ]
          );
          return [lat, lon];
        });
      emitCoords(coords);
    };
    reader.readAsArrayBuffer(file);
    e.target.value = '';
  };

  const btnStyle = {
    flex: 1,
    margin: '0 4px',
    padding: '8px 0',
    fontSize: 14,
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer'
  };

  return (
    <div style={{
      position: 'absolute',
      top: 230, left: 285, zIndex: 2100,
      width: 360, background: '#fff', padding: 12, borderRadius: 6,
      boxShadow: '0 2px 6px rgba(0,0,0,0.25)', color: '#000'
    }}>
      <p>Вставьте текст или импортируйте Excel-файл:</p>
      <pre style={{
        fontSize: 12, background: '#f5f5f5', padding: 8,
        maxHeight: 100, overflowY: 'auto'
      }}>
{`в точке  X=10224.6382  Y=3114.8992
в точке  X=10274.8285  Y=3171.4350
…`}
      </pre>
      <textarea
        rows={4}
        style={{ width: '100%', marginBottom: 8 }}
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="в точке  X=…  Y=…"
      />
      <input
        ref={fileInputRef}
        type="file"
        accept=".xls,.xlsx"
        style={{ display: 'none' }}
        onChange={handleFileUpload}
      />
      <div style={{ display: 'flex' }}>
        <button
          onClick={onCancel}
          style={{ ...btnStyle, backgroundColor: '#dc3545' }}
        >
          Отмена
        </button>
        <button
          onClick={handleDraw}
          disabled={!text.trim()}
          style={{
            ...btnStyle,
            backgroundColor: '#28a745',
            opacity: text.trim() ? 1 : 0.6,
            cursor: text.trim() ? 'pointer' : 'not-allowed'
          }}
        >
          Начертить
        </button>
        <button
          onClick={() => fileInputRef.current.click()}
          style={{ ...btnStyle, backgroundColor: '#007bff' }}
        >
          Импорт из Excel
        </button>
      </div>
    </div>
  );
}
